import { ServiceType } from '../API';

export type ServiceTypeConfig = {
  isDropOffRequired: boolean;
  isCareNavigationServiceType?: boolean;
  // flag that indicates that service requires remote tech
  hasRemoteComponent: boolean;
};

export const SERVICE_TYPE_CONFIGS: {
  [serviceType in ServiceType]: ServiceTypeConfig;
} = {
  [ServiceType.REMOTE_TECH_EVALUATION]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: true,
  },
  [ServiceType.SDOH_CARE_NAVIGATION_RESOURCE_GUIDANCE]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.CARDIAC_AUSCULTATION]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.DIABETIC_FOOT_SCREENING]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.DIABETIC_RETINAL_SCAN]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.ECG]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.BLOOD]: {
    isDropOffRequired: true,
    hasRemoteComponent: false,
  },
  [ServiceType.URINE]: {
    isDropOffRequired: true,
    hasRemoteComponent: false,
  },
  [ServiceType.CAPILLARY_BLOOD_DRAW]: {
    isDropOffRequired: true,
    hasRemoteComponent: false,
  },
  [ServiceType.MISCELLANEOUS_SPECIMEN]: {
    isDropOffRequired: true,
    hasRemoteComponent: false,
  },
  [ServiceType.RAPID_COVID_TEST]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.VITALS]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.XRAY]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.FIT_KIT_PICKUP]: {
    isDropOffRequired: true,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.CARE_NAVIGATION]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.KIT_DELIVERY_AND_EDUCATION]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.RACE_AND_ETHNICITY]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.SDOH_QUESTIONNAIRE]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.KIT_DELIVERY]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.DEXA_SCAN_CARE_NAVIGATION_BOOKING]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: true,
    hasRemoteComponent: false,
  },
  [ServiceType.DEXA_SCAN_CARE_NAVIGATION_CONFIRMATION]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: true,
    hasRemoteComponent: false,
  },
  [ServiceType.MAMMOGRAM_CARE_NAVIGATION_BOOKING]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: true,
    hasRemoteComponent: false,
  },
  [ServiceType.MAMMOGRAM_CARE_NAVIGATION_CONFIRMATION]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: true,
    hasRemoteComponent: false,
  },
  [ServiceType.PCP_VISIT_CARE_NAVIGATION_BOOKING]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: true,
    hasRemoteComponent: false,
  },
  [ServiceType.PCP_VISIT_CARE_NAVIGATION_CONFIRMATION]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: true,
    hasRemoteComponent: false,
  },
  [ServiceType.HEIGHT_AND_WEIGHT_COLLECTION]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.COLOGUARD_KIT_EDUCATION]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.COLOGUARD_KIT_ORDERING]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.ANNUAL_WELLNESS_VISIT_PROVIDER_CALL]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: true,
    // For the pilot, we only want to do remote appointments for WCCs. When Remote AWVs is launched, we should set this to true.
  },
  [ServiceType.PAIN_SCREENING]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.BONE_DENSITY_SCAN]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.TOPICAL_FLUORIDE]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: false,
  },
  [ServiceType.STATIN_ADHERENCE_ASSESSMENT]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: true,
  },
  [ServiceType.WEIGHT_COUNSELING_FOR_CHILDREN]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: true,
  },
  [ServiceType.RISK_ASSESSMENT]: {
    isDropOffRequired: false,
    isCareNavigationServiceType: false,
    hasRemoteComponent: true,
  },
};

/**
 * @param serviceType - The service type to get the config for
 */
export default function getServiceTypeConfig(serviceType: ServiceType): ServiceTypeConfig {
  return SERVICE_TYPE_CONFIGS[serviceType];
}
